import { userLogoutRequest } from "@/lib/features/authSlice";
import { ReducerType } from "@/lib/store";
import { EAdminType } from "@/models/user";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

export default function UseAuth() {
  const { user, configs } = useSelector((state: ReducerType) => state.auth);
  const dispatch = useDispatch();
  const logout = () => {
    dispatch(userLogoutRequest());
    window.location.reload();
  };
  const [isLoading, setIsLoading] = useState<boolean>(true);
  useEffect(() => {
    if (!user) {
      setIsLoading(false);
      return;
    }
    if (user) {
      setIsLoading(false);
      return;
    }
  }, [user]);

  return {
    isLoading,
    user,
    configs,
    isLoggedIn: !!user,
    isAdmin:
      user?.adminTypeId === EAdminType.ADMIN ||
      user?.adminTypeId === EAdminType.SUPER_ADMIN,
    isSuperAdmin: user?.adminTypeId === EAdminType.SUPER_ADMIN,
    isGuest: user?.adminTypeId === EAdminType.GUEST,
    logout: logout,
  };
}
